<template>
  <div class="inputs" ref="inputs" style="width: 100%;">

    <!-- 上传按钮绑定click事件 -->
      <el-button size='small' type="primary" @click="uploadBtnClick()" v-if="permission_sub != 'r'">
      上传
      <i class="el-icon-upload el-icon--right"></i>
      </el-button> 

      <el-dialog title="附件上传" :visible.sync="dialogVisible" width="30%">
          <el-upload
            ref="upload" 
            drag
            :permission="permission_sub"
            :class="{'ht__file-readonly':permission==='r'}"
            :action="actionUrl"
            :file-list="files"
            :headers="header"
            :show-file-list="false"
            :before-remove="beforeRemove"
            :accept="acceptType"
            :limit="limits"
            :multiple="multiple"
            :on-success="success"
            :on-progress="progress"
            :before-upload="beforeAvatarUpload"
            :http-request="httpRequest"
          >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>


          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
          </span>
      </el-dialog>

      <el-table v-if="filesData.length>0" :data="filesData" border :style="'width:98%;'" size="mini">

      <el-table-column label="序号" align="center" type="index" width="70"></el-table-column>

      <el-table-column   label="附件名称" align="center">
        <template slot-scope="scope">
          <span class="done-subject" @click="preview(scope.row)">{{scope.row.name}}</span>
        </template>
        <IframeSrc ref="iframeSrcSearch" :iframeSrc="iframeSrc"/>
      </el-table-column>

      <el-table-column   label="附件类型" align="center" width="80">
        <template slot-scope="scope">
          <span class="done-subject" @click="preview(scope.row)">{{scope.row.type}}</span>
        </template>
        <IframeSrc ref="iframeSrcSearch" :iframeSrc="iframeSrc" />
      </el-table-column>

      <el-table-column   label="附件大小" align="center" width="120">
        <template slot-scope="scope">
          <span class="done-subject" @click="preview(scope.row)">{{scope.row.size}}/kb</span>
        </template>
        <IframeSrc ref="iframeSrcSearch" :iframeSrc="iframeSrc" />
      </el-table-column>

      <el-table-column   label="上传人" align="center" width="80">
        <template slot-scope="scope">
          <span class="done-subject" @click="preview(scope.row)">{{scope.row.username}}</span>
        </template>
        <IframeSrc ref="iframeSrcSearch" :iframeSrc="iframeSrc" />
      </el-table-column>

      <el-table-column  align="center" label="操作" width="120">
        <template slot-scope="scope">
           <el-popconfirm title="附件可通过点击附件名称在线预览，确定要下载至本地吗？" @onConfirm="download(scope.row)">
            <el-button slot="reference" type="success" size="mini" icon="el-icon-download" plain></el-button>
          </el-popconfirm>
          <el-popconfirm title="确定删除吗？" @onConfirm="beforeRemove(scope.row)" v-if="permission_sub != 'r'">
            <el-button slot="reference" type="danger" size="mini" icon="el-icon-delete" plain></el-button>
          </el-popconfirm>
        </template>
      </el-table-column>

    </el-table>
  <ht-input style="display:none" :name="inputName" v-model="filesData" :validate="inputValidate" :permission="permission_sub"></ht-input>
    <!-- 预览压缩文件-->
    <FilePreview ref="filePreview" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import utils from "@/utils.js";
import req from "@/request.js";
import FilePreview from "@/components/common/FilePreview.vue";
import { Message } from "element-ui";
import sub_pio_mixin from "@/sub-permission-mixin.js";
import { Loading } from 'element-ui';
import IframeSrc from "@/components/common/iframeSrc.vue";
export default {
  name: "eip-attachment",
  components: { 
    FilePreview,
    IframeSrc
  },
  props:{
    validate: {
      type: String
    },
    value: {
      type: String
    },
    name: {
      type: String
    },
    permission: null,
    size: {
      type: Number,
      default: 200
    },
    limit: null,
    multiple: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String
    },
    propConf: null,

  },
  mixins: [sub_pio_mixin],//混入方式引入表单组件，处理子表点击当前行可编辑（切面修改permission）
  data() {
    return {
      filesData:[],
      num:0,
      list:[],
      files:[],
      limits: 9999,
      propConfList: [],
      inputVal: this.value,
      src: "",
      fileId: "",
      fileTree: "",
      iframeSrc: "",
      acceptFile: "",
      newValidate: null,
      oldFile:[],
      zzFile:[],
      // 添加属性，默认值为false,表示弹框不显示
      dialogVisible: false,
      //当前点击打开弹框的按钮在表格中是那一列
      currentIndex: 0,
      //上传成功的文件
      currentAttachList:[],

      tableData: [{
        attachList:[]
      }]


    };
  },
  computed: mapState({
    /*inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      var validateObj = this.$store.state.index.validate;
      return utils.addRequiredOrNot(
        this.permission,
        this.validate,
        validateObj,
        this
      );
    },*/
    inputValidate: function() {
      if (this.newValidate) {
        return this.newValidate;
      }
      return this.validate;
    },
    header: state => {
      return { Authorization: `Bearer ${state.login.currentUser.token}` };
    },
    actionUrl: function() {
      return req.getContext().portal+"/system/file/v1/upload";
    } ,
    inputName: function() {
      let labeldesc = "";
      if (
        this.$slots &&
        this.$slots.labeldesc &&
        this.$slots.labeldesc[0].children &&
        this.$slots.labeldesc[0].children[0].text
      ) {
        labeldesc = this.$slots.labeldesc[0].children[0].text;
        return this.name ? this.name : utils.getName() + "-" + labeldesc;
      } else {
        return this.name ? this.name : utils.getName();
      }
    },
    acceptType: function() {
      if (!this.accept) {
         return "";
      }
      let acceptTypeArr = [];
      for(let i=0,type;type=this.accept.split(',')[i++];){
          acceptTypeArr.push('.'+type);
      }
      return acceptTypeArr.join(',');
    }
  }),
  watch: {
    inputVal(val) {
      this.$emit("input", val);
    },
    files: {
      handler(newVal, oldVal) {
         this.$emit("input", JSON.stringify(newVal));
      },
      deep: true
    }
  },
  mounted() {
    if (this.limit) {
      this.limits = Number(this.limit);
    }
  },
  beforeDestroy() {},
  destroyed() {},
  created() {
    if(this.filesData.length<1 && this.inputVal.length>0){
      let jsonData = JSON.parse(this.inputVal);
      for(let i=0;i<jsonData.length;i++){
        jsonData[i].size = jsonData[i].size
        jsonData[i].type = utils.substringType(jsonData[i].name, ".")
      }
      this.filesData = jsonData;
    }

    if (this.propConf) {
      let list = JSON.parse(this.propConf);
      list.forEach(element => {
        if (element.desc) {
          if (element.requried) {
            element.inputValidate = "required:true";
          }
          this.propConfList.push(element);
        }
      });
    }
    if (this.accept) {
      this.acceptFile = "." + this.accept.split(",").join(",.");
    }
    this.$validator = this.$root.$validator;
  },
  methods: {
    onSuccess(file) {},
    beforeAvatarUpload(file) {
      if(!this.accept || typeof(this.accept) == 'undefined'){
        return true;
      }
      // 文件类型限制
      const name = file.name ? file.name : "";
      const ext = name
        ? name.substr(name.lastIndexOf(".") + 1, name.length)
        : true;
      const isExt = this.accept.indexOf(ext) < 0;
      if (isExt) {
        if (this.accept == "" || this.accept == undefined) {
          this.$message.error("请配置可上传文件的格式!");
        } else {
          this.$message.error("上传的附件只能是 " + this.accept + "格式!");
        }
      }
      return !isExt;
    },
    download(file) {
      if (!file.response){
        req.download("${portal}/system/file/v1/downloadFile?fileId=" +  file.id);
      }else{
        req.download("${portal}/system/file/v1/downloadFile?fileId=" +  file.response.fileId);
      }
    },
    // preview(files) {
    //   debugger;
    //   if (!files.response) {
    //     //预览旧数据
    //     if(!(files.id && files.id.length == 14)){
    //       this.$message.warning("请稍后再试！");
    //       return;
    //     }else{
    //       let obj = {};
    //       obj.id = files.id;
    //       obj.name = files.name;
    //       obj.size = 0;
    //       this.$refs.filePreview.preview(obj);
    //       return ;
    //     }

    //   }
    //   var fileData = files.response;
    //   var id = fileData.fileId;
    //   let obj = {};
    //   obj.id=fileData.fileId;
    //   obj.name=fileData.fileName;
    //   obj.size=fileData.size;
    //   this.$refs.filePreview.preview(obj);
    // },
preview(row) {//附件预览
      this.files;
      this.filesData;
      let fileid;
      if (!row.response){
        fileid = row.id;
      }else{
        fileid = row.response.fileId;
      }
      
      let idocType = ["doc","docx","xls","xlsx","ppt","pptx","pdf","txt","jpg","jpeg","gif","png","bmp","tif","mp3","m4a","mid","wma","mp4","zip","rar","tar","7z"];
      let type;// = row.name.substr(row.name.lastIndexOf(".") + 1);
      let filepath;
      this.$http.post(`${window.context.portal}/bpm/aliasScript/v1/execute/FileType?id=${fileid}`).then((resp) => {debugger;
         type = resp.data.value[0].FILETYPE;
         filepath = resp.data.value[0].FILEPATH;
           
         setTimeout(() => {
          if (idocType.includes(type)) {
            let token = "testtoken";
            let url = encodeURIComponent(window.context.portal+"/system/file/v1/downloadFile?fileId=" +fileid);
            let idocvUrl = "http://10.10.10.74:8168";
            //***** 外网 *****/
            if(window.location.origin.indexOf("http://61.144.170.91")>-1){//副线环境
              idocvUrl = "http://61.144.170.91:8168";
            }

            if(window.location.origin.indexOf("http://zs.haiya.com.cn")>-1){//副线环境
              idocvUrl = "http://61.144.170.91:8168";
            }

            this.$http.get(`${idocvUrl}/doc/upload?token=${token}&url=${url}`).then((resp2) => {
                this.iframeSrc =   idocvUrl+"/view/" + resp2.data.uuid;
                this.$refs.iframeSrcSearch.handleOpen();
              })
           }else{
                this.download(row);
            }
          }, 100);
      });

    },


    //控制上传附件控件打开
    uploadBtnClick (){
       // 获取上传按钮对应那一列表格数据中的附件列表，赋值给currentAttachList
      this.currentAttachList = this.tableData[0].attachList;
      // 将控制弹框显示的dialogVisible设置为true，让弹框显示
      this.dialogVisible = true;
    },
    //删除附件json
    beforeRemove(file,fileList) {
      let arr = [];
      debugger;
      for(let i=0;i<this.filesData.length;i++){
        if(this.filesData[i].response){
          if(file.response){
            if(this.filesData[i].response.fileId != file.response.fileId){
              arr.push(this.filesData[i]);
            }
          }else{
            if(this.filesData[i].response.fileId != file.id){
              arr.push(this.filesData[i]);
            }
          }
        }else{
          if(file.response){
            if(this.filesData[i].id != file.response.fileId){
              arr.push(this.filesData[i]);
            }
          }else{
            if(this.filesData[i].id != file.id){
              arr.push(this.filesData[i]);
            }
          }
        }
      }
      this.filesData = arr;
      this.$emit("input", JSON.stringify(arr));
    },
    uploadSuccess(response, file, fileList){
      console.log(file);
      console.log(fileList);
      this.tableData[0].attachList.push({
        'name':file.name
      });
      console.log(file);
    },


    intLimit: function() {//附件个数
      if(!this.multiple) return 1;
      return this.limit?parseInt(this.limit) :5;
    },
    success(response,file, fileList){
      this.filesData;
      debugger;
      this.$refs.upload.fileList.splice(0); //上传成功之后清除历史记录
      this.oldFile=[];
      for(let i=0;i<this.filesData.length;i++){
        this.oldFile.push(this.filesData[i]);
      }
      for(let i=0;i<fileList.length;i++){
        this.oldFile.push(fileList[i]);
      }
      //let loadingInstance = Loading.service();
      //this.$nextTick(() => { 
        // 以服务的方式调用的 Loading 需要异步关闭
        //loadingInstance.close();
      //});
      this.oldFile;
      debugger;
      //if(this.num==fileList.length){
        for(let i = 0;i<this.oldFile.length;i++){
          if(this.oldFile[i].response){
            let value = this.oldFile[i].response;
            let arrarFile = {};
            arrarFile.id = value.fileId;
            arrarFile.name = value.fileName;
            arrarFile.size = (value.size/1024).toFixed(2);
            arrarFile.username = JSON.parse(sessionStorage.getItem("currentUser")).username;
            this.files.push(arrarFile);
          }
          if(!this.oldFile[i].response){
            let arrarFile = {}; 
            arrarFile.id = this.oldFile[i].id;
            arrarFile.name = this.oldFile[i].name;
            arrarFile.size = (this.oldFile[i].size/1024).toFixed(2);
            arrarFile.username = JSON.parse(sessionStorage.getItem("currentUser")).username;
            this.files.push(arrarFile);
          }
        }
        
        this.filesData = [];
        for(let i=0;i<this.files.length;i++ ){
          this.filesData.push({id:this.files[i].id,name:this.files[i].name,size:this.files[i].size,type:utils.substringType(this.files[i].name,"."),bytes:utils.bigDecimal(this.files[i].size),username:this.files[i].username});
        }
        this.$emit("input", JSON.stringify(this.filesData));
        this.files=this.filesData;
      //}
      
      debugger;
      this.dialogVisible = false;
    },
        //文件上传时
    progress(event,file, fileList){
      //Loading.service();
    },
    httpRequest(param){
      this.oldFile=[];
      for(let i=0;i<this.filesData.length;i++){
        this.oldFile.push(this.filesData[i]);
      }
   

      this.oldFile;
      debugger;
      const formData = new FormData();
      formData.append("files", param.file);
      this.$http.post(param.action,formData).then((resp) => {
        if(resp.data.success==true || resp.data.success=='true'){//上传成功
          let obj = {
            bytes: utils.bigDecimal(resp.data.size),
            id: resp.data.fileId,
            name: resp.data.fileName,
            size: resp.data.size,
            type: utils.substringType(resp.data.fileName,"."),
            username: resp.data.username
          }

          this.oldFile.push(obj);
          console.log(this.oldFile);
          debugger;
          this.filesData = [];
          for(let i=0;i<this.oldFile.length;i++ ){
           this.filesData.push({id:this.oldFile[i].id,name:this.oldFile[i].name,size:this.oldFile[i].size,type:utils.substringType(this.oldFile[i].name,"."),bytes:utils.bigDecimal(this.oldFile[i].size),username:this.oldFile[i].username});
          }

          this.$emit("input", JSON.stringify(this.filesData));
          this.files=this.filesData;
          this.dialogVisible = false;
        }
      })
      
    },

  }
};
</script>
<style lang="scss" scoped>
div[aria-invalid='true'] /deep/ .el-input__inner, div[aria-invalid='true'] /deep/ .el-input__inner:focus {
  border-color: #f56c6c;
}
.ht__file-readonly{
  /deep/.file-upload-container{
    display:none;
  }
}
.ht__file-content{
  /deep/ thead{
    tr{
      line-height: 32px;
    }
  }
  /deep/.el-table__row{
    td{
      padding: 3px 10px;
    }
  }
}
</style>
